// ** Third Party Components
import { Check, Download, Edit, Eye, Info, X } from 'react-feather'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Button, Spinner } from 'reactstrap'
import toast from 'react-hot-toast'

import { Icon } from '@iconify/react'
import { setOpenModal } from '../store'
// ** Table Common Column

const SERVICES_DIGITAL_SIGNATURE = {
  '01': 'Api de Firma',
  '02': 'Portal completo'
}

const SERVICE_DIGITAL_FACTURA = {
  '01': 'Api de Facturación',
  '02': 'Portal de consultas',
  '03': 'Portal completo'
}

const CustomActions = ({ row }) => {
  const dispatch = useDispatch()
  const handleDelete = () => {
    return toast.success('Muy pronto estará disponible esta funcionalidad')
  }

  const handleEdit = () => {
    return dispatch(setOpenModal({ type: 'edit', open: true, data: row }))
  }

  return (
    <div className="d-flex align-items-center justify-content-center gap-1">
      <>
        <Button
          size="sm"
          outline
          className="cursor-pointer"
          onClick={handleEdit}
        >
          <Icon icon="bx:edit" />
        </Button>
        <Button
          size="sm"
          outline
          className="cursor-pointer"
          onClick={handleDelete}
        >
          <Icon icon="material-symbols:delete" />
        </Button>
      </>
    </div>
  )
}

export const columns = () => [
  {
    name: 'Sociedad',
    width: '10%',
    // center: true,
    selector: (row) => row.company,
    sortable: true,
    cell: (row) => (
      <div className="d-flex align-items-center text-center">{row.company}</div>
    )
  },
  {
    name: 'Typo de persona',
    width: '10%',
    // center: true,
    sortable: true,
    selector: (row) => row?.personType
  },
  {
    name: 'NIT',
    width: '10%',
    // center: true,
    sortable: true,
    selector: (row) => row?.nit
  },
  {
    name: 'NRC',
    width: '10%',
    // center: true,
    sortable: true,
    selector: (row) => row?.nrc
  },
  {
    name: 'Adm. Principal',
    width: '15%',
    sortable: true,
    // center: true,
    selector: (row) => row?.admin
  },
  {
    name: 'Servicio de firma digital',
    width: '12%',
    // center: true,
    sortable: true,
    selector: (row) =>
      (row?.service ? SERVICES_DIGITAL_SIGNATURE[row.service] : 'N/A')
  },
  {
    name: 'Servicio factura digital',
    width: '15%',
    // center: true,
    sortable: true,
    selector: (row) =>
      (row?.service ? SERVICE_DIGITAL_FACTURA[row.serviceDigital] : 'N/A')
  },
  {
    name: 'Activo',
    width: '8%',
    center: true,
    cell: (row) => (
      <div className="d-flex align-items-center justify-content-center">
        {row.isActive ? <Check /> : <X />}
      </div>
    )
  },
  {
    name: 'Acciones',
    width: '10%',
    // center: true,
    selector: '',
    cell: (row) => <CustomActions row={row} />
  }
]
